// extracted by mini-css-extract-plugin
export var copyableField = "_oo-4";
export var customerBadge = "_oo-0";
export var customerInfoTitle = "_oo-2";
export var details = "_oo-1";
export var dropdownContainer = "_oo-5";
export var dropdownImage = "_oo-6";
export var editAssigneeForm = "_oo-a";
export var editButton = "_oo-3";
export var email = "_oo-7";
export var hidden = "_oo-d";
export var input = "_oo-8";
export var saveButton = "_oo-b";
export var shopifyIcon = "_oo-c";
export var suggestionBadge = "_oo-e";
export var suggestionText = "_oo-f";
export var username = "_oo-9";